var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sw-game"},[_c('router-view'),[_c('audio',{attrs:{"id":"button-audio","src":"static/clickSound.wav","type":"audio/wav"}}),_c('audio',{attrs:{"id":"background-audio","src":'static/'+_vm.backgroundAudio+'.mp3',"type":"audio/mp3","loop":""}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }